export default "__VITE_ASSET__DUe8PtJk__"